import { Teacher } from './../../../../../shared/src/lib/model/teacher.model';
import { HttpParams } from '@angular/common/http';
import { ConversationService } from './../../../../../shared/src/lib/service/conversation.service';
import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { AuthenticationService } from '../../../../../shared/src/lib/service/authentification.service';
import { environment } from '../../../../../environments/environment';
import { Router } from '../../../../../../node_modules/@angular/router';
@Component({
  selector: 'app-desktop-menu',
  templateUrl: './desktop-menu.component.html',
  styleUrls: ['./desktop-menu.component.scss']
})
export class DesktopMenuComponent implements OnInit, OnDestroy {
  myUser: Teacher;
  defaultAvatar = environment.static + '/avatar.png';
  nb_unreadMessages = 0;
  unread_examination_variants_count = 0;
  @Output() goToLogout: EventEmitter<any> = new EventEmitter();

  hasDefaultTag: boolean = false;

  constructor(
    private authenticationService: AuthenticationService,
    private conversationService: ConversationService,
  ) { }

  ngOnInit() {
    this.authenticationService.currentUserSubject.subscribe(
      user => {
        if (user) {
          this.unread_examination_variants_count = user.unread_examination_variants_count;
        }
      }
    );
    this.myUser = this.authenticationService.getCurrentPersona();
    this.conversationService.conversationList.subscribe(conversationList => {
      if (conversationList.length > 0) {
        this.nb_unreadMessages = conversationList.map(c => c.unread_teacher).reduce((acc, value) => Number(acc) + Number(value), 0);
      }
    })
    if (this.myUser && this.myUser.specific_content) {
      this.myUser.specific_content.forEach(
        content => {
          if (content.code === 'default' || content.code === 'cost_effective') {
            this.hasDefaultTag = true;
          }
        }
      )  
    }
  }
  ngOnDestroy() {
    this.nb_unreadMessages = 0;
  }



  logout() {
    this.goToLogout.emit();
  }

  checkAvailableLanguageSheets() {
    return this.authenticationService.checkAvailableLanguageSheets(this.myUser.teach_language.id);
  }

  checkFeaturePermission(groupName) {
    return this.authenticationService.checkFeaturePermission(groupName);
  }

}
